import { formatDisplayDate, parseDisplayDate, toIsoDate } from "../lib/dates";

// A date that the public page shows as text ("December 24, 2026"), edited
// with the same browser date box as "Visible from". Older rows typed by hand
// (12242026, 12/24/26, ...) are read by the converter and shown in the box;
// the hint says when saving will rewrite them, and flags text that is not a
// date at all.
export function DateTextField({ label, value, onChange }: { label: string; value: string; onChange: (value: string) => void }) {
  const parsed = parseDisplayDate(value);
  const formatted = parsed ? formatDisplayDate(parsed) : null;
  const invalid = Boolean(value.trim()) && !formatted;
  const hint = !value.trim() ? "Pick the date shown on the page."
    : invalid ? `Saved text “${value}” is not a date. Pick one.`
    : formatted === value ? `Shown on the page as “${formatted}”.`
    : `Will be saved as “${formatted}”.`;

  return <label className="field">
    <span>{label}</span>
    <input type="date" value={parsed ? toIsoDate(parsed) : ""} aria-invalid={invalid}
      onChange={(e) => { const p = parseDisplayDate(e.target.value); onChange(p ? formatDisplayDate(p) : ""); }}/>
    <small className={invalid ? "field-error" : undefined}>{hint}</small>
  </label>;
}
